import {INIT_URL, SIGNOUT_USER_SUCCESS,SIGNOUT_ROLE_SUCCESS, USER_DATA, USER_TOKEN_SET,USER_ROLE_SET} from "../../constants/ActionTypes";

const INIT_STATE = {
  token: JSON.parse(localStorage.getItem('token')),
  initURL: '',
  authUser: JSON.parse(localStorage.getItem('user')),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }
    case SIGNOUT_ROLE_SUCCESS: {
      return {
        ...state,
        role: null
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case USER_ROLE_SET: {
      return {
        ...state,
        role: action.payload,
      };
    }
    default:
      return state;
  }
}
